<template>
  <div class="graph-card" role="graph" title="Parent Quality Survey Ratings" aria-describedby="parent-rating-description">
    <div class="graph-card-header" :style="{'background-color': this.headerColor}">
      <div class="g-heading">
        <h2>Parent Quality Survey Ratings</h2>
        <p>{{ data.year }}</p>
      </div>
      <div
        class="tooltip-icon"
        tabindex="0"
        @mouseenter="toggleTooltip(1)"
        @mouseleave="toggleTooltip(0)"
        @keydown.enter="toggleTooltip(1)"
        @keyup.enter="toggleTooltip(0)">
      </div>
    </div>
    <div class="graph-card-body" :style="{'background-color': this.bodyColor}">
      <cmps-pie :data="chartData" :styles="stylesObject" aria-hidden="true"></cmps-pie>
      <div class="tooltip-text" ref="tooltip" aria-hidden="true" style="z-index: 999;">
        <p id="parent-rating-description">State law requires all schools to survey all of their students parents each year using an A - F grading system.</p>
      </div>
      <table class="sr-only">
        <thead>
          <tr>
            <th>Year</th>
            <th>'A' plus</th>
            <th>'A'</th>
            <th>'B'</th>
            <th>less than 'B'</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ this.data.year }}</td>
            <td>{{ this.data.aplus }} %</td>
            <td>{{ this.data.a }} %</td>
            <td>{{ this.data.b }} %</td>
            <td>{{ this.data.lessb }} %</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div> <!-- end graph-card -->

</template>

<script>
  import Pie from './charts/Pie.vue'

  export default {
    components: {
      cmpsPie: Pie
    },
    props: ['data', 'headerColor', 'bodyColor'],
		data() {
			return {
        chartData: {
          datasets: [
            {
              data: [this.data.aplus, this.data.a, this.data.b, this.data.lessb],
              backgroundColor: ['#7fbf7f', '#ffff7f', '#ffd27f', '#ff7f7f'],
              // borderColor: 'black',
              borderWidth: 1,
              // hoverBackgroundColor: 'lightblue'
            }
          ],
          labels: ['A+ (' + this.data.aplus + '%)', 'A (' + this.data.a + '%)', 'B (' + this.data.b + '%)', '< B (' + this.data.lessb + '%)']
        },
        stylesObject: {
          // height: '350px',
          position: 'relative'
        }
      }
		},
    methods: {
      toggleTooltip(value) {
        this.$refs.tooltip.style.left = value === 1 ? '0' : '99999px'
        this.$refs.tooltip.style.opacity = value
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/_graphs.scss';
</style>
